"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookiesToTransform = void 0;
var _presentationUtils = require("@ori/presentation-utils");
// The cookies are processed in the order they appear in this array,
// and processing stops at the first found cookie that has stopIfFound == true
const cookiesToTransform = exports.cookiesToTransform = [{
  cookie: _presentationUtils.PbsCookieNames.PBS_CODE,
  queryParam: 'store',
  stopIfFound: true
}, {
  cookie: _presentationUtils.PbsCookieNames.ECREF_OWNER,
  queryParam: 'invite',
  stopIfFound: true
}, {
  cookie: _presentationUtils.PbsCookieNames.PBS_OWNER,
  queryParam: 'store',
  stopIfFound: false
}, {
  cookie: _presentationUtils.PbsCookieNames.ECREF,
  queryParam: 'invite',
  stopIfFound: true
}];
